import React, { useEffect, useRef } from 'react';
import T from 'prop-types';
import { useDispatch } from 'react-redux';

import MarketOverview from '../components/MarketOverview';
import TrendsSummary from '../components/TrendsSummary';
import TimeSpentPenetration from '../components/TsPenetration';
import MarketBehavior from '../components/MarketBehavior';
import AppImpact from '../components/AppImpact';
import FullAccessBanner from '../components/FullAccessBanner';
import SectorsStats from '../components/SectorsStats';
import AppTrends from '../components/AppTrends';
import AiStickyHeader from '../components/AiStickyHeader';
import AiTabNavigation from '../components/AiTabNavigation';
import TabExportButton from '../components/TabExportButton';
import AiDashboardStaticView from '../components/AiDashboardStaticView';
import PreviewTopBanner from '../components/PreviewTopBanner';
import PreviewBottomSection from '../components/PreviewBottomSection';
import Container from '../../../components/Container';
import { fetchAiDashboardData } from '../actions';
import { scrollToSection } from '../hooks/useAiDashboardNav';

const AiDashboardContainer = ({
  isPublic = false,
  campaignEnded = false,
  showAiBanner = false,
  isPress = false,
}) => {
  const dispatch = useDispatch();

  const stickySentinelRef = useRef(null);

  useEffect(() => {
    dispatch(fetchAiDashboardData({ campaignEnded }));
  }, [dispatch, campaignEnded]);

  return (
    <>
      {(isPublic || showAiBanner) && <PreviewTopBanner campaignEnded={campaignEnded} />}
      <div className="ai-dashboard-tab">
        <AiStickyHeader stickySentinelRef={stickySentinelRef} />
        <Container maxWidth={1128}>
          <header className="ai-dashboard-tab-content-header">
            <AiTabNavigation isPress={isPress} onScrollToSection={scrollToSection} />
            {!isPress && <TabExportButton isPublic={isPublic || campaignEnded} />}
          </header>
          <div ref={stickySentinelRef} className="sticky-sentinel" />
          <div className="ai-dashboard-tab-content">
            {campaignEnded ? (
              <AiDashboardStaticView />
            ) : (
              <>
                <div id="market-overview">
                  <MarketOverview allowQV={!isPublic && !isPress} isPress={isPress} />
                </div>
                <div className="separator-h" />
                {isPublic && <FullAccessBanner />}
                <div id="behavioral-trends">
                  <TrendsSummary allowQV={!isPublic && !isPress} />
                </div>
                <div id="share-of-screen-time">
                  <TimeSpentPenetration isPress={isPress} />
                </div>
                <div id="market-behavior">
                  <MarketBehavior isPress={isPress} />
                </div>
                <div id="screen-time-by-sector">
                  <SectorsStats />
                </div>
                <div id="app-trends">
                  <AppTrends isPress={isPress} />
                </div>
                <div id="ai-app-impact">
                  <AppImpact isPublic={isPublic} isPress={isPress} />
                </div>
              </>
            )}
          </div>
        </Container>
      </div>
      {isPublic && <PreviewBottomSection />}
    </>
  );
};

AiDashboardContainer.propTypes = {
  isPublic: T.bool,
  campaignEnded: T.bool,
  showAiBanner: T.bool,
  isPress: T.bool,
};

export default AiDashboardContainer;
